// extracted by mini-css-extract-plugin
export default {"container":"error-message_container__BYryY"};